import React from 'react';

import styled, { css } from 'styled-components';
import { convertHexToRGBA } from 'utils/convertHexToRgba';
import { useTranslations } from 'hooks/useTranslations';

import dynamic from 'next/dynamic';
import router from 'next/router';
import { useCart } from 'hooks/useCart';

const DsTypography = dynamic(() => import('componentsV2/DS/Typography'), {
  ssr: false,
});

const SellerBoxStyle = ({ theme, isUpsell }) => css`
  background-color: ${convertHexToRGBA(
    theme.color.neutral.pure,
    theme.opacity.light
  )};
  text-align: center;
  padding: 14px 0;
  font-family: ${theme.font.family.primary};
  border-bottom: ${theme.border.width.hairline} solid
    ${theme.color.neutral.mediumContrast};

  dsb-typography {
    dsb-typography {
      &::part(typography) {
        color: ${theme.color.secondary.pure};
      }
    }
  }

  p {
    font-size: 14px;
    padding: 0 10px;
    color: ${theme.color.neutral.pure};
    margin: 0;

    strong {
      font-weight: bold;
      color: ${theme.color.secondary.pure};
    }
  }
`;

const SellerBoxStyled = styled.div([SellerBoxStyle]);

export default function SellerBox({ dataCy }) {
  const context = useCart();
  const { tSeller } = useTranslations();

  return (
    <SellerBoxStyled
      data-cy={dataCy}
      isUpsell={
        router.pathname.includes('upsell') ||
        router.pathname === '/subscription-welcome'
      }
    >
      <DsTypography
        component="paragraph"
        size="small-bold"
        color="neutral-pure"
      >
        {tSeller('label')}
        <DsTypography
          component="paragraph"
          size="small-bold"
          color="secondary-pure"
        >
          {context.sellerName}
        </DsTypography>
      </DsTypography>
    </SellerBoxStyled>
  );
}
